import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HoursOfOperation, BusinessWeek, HoursOfOperationType } from '@models/hoursofoperation';
import { HoursOfOperationService, getBusinessWeek, getHoursOfOperationDays } from '@services/hoursofoperation.service';

@Component({
  selector: 'app-hours-of-operation',
  templateUrl: './hours-of-operation.component.html',
  styleUrls: ['./hours-of-operation.component.less'],
})
export class HoursOfOperationDialogComponent implements OnInit {
  public dialog: MatDialog;

  businessWeek: BusinessWeek;

  constructor(
    public dialogRef: MatDialogRef<HoursOfOperationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: { clinicId: number; currentHours: HoursOfOperation; hoursType: HoursOfOperationType },
    private hoursOfOperationService: HoursOfOperationService
  ) {}

  ngOnInit() {
    this.businessWeek = getBusinessWeek(this.dialogData.currentHours.hoursOfOperationDays);
  }

  save() {
    const days = getHoursOfOperationDays(this.businessWeek);
    this.dialogData.currentHours.hoursOfOperationDays = days;
    if (this.dialogData.currentHours.hoursOfOperationId == null) {
      this.dialogData.currentHours.hoursOfOperationId = 0;
    }

    // Any changes will be reflected only in the local model and will ony be updated or added
    // when the user clicks 'Add' or 'Update'
    if (this.dialogData.clinicId) {
      this.dialogRef.close(this.dialogData.currentHours);
      return;
    }

    //I've left this all in case in the future ideas change and it needs to be reused
    if (this.dialogData.hoursType === HoursOfOperationType.Clinic) {
      this.hoursOfOperationService
        .saveClinicHoursOfOperation(this.dialogData.clinicId, this.dialogData.currentHours)
        .subscribe(
          (res) => {
            this.dialogRef.close(res);
          },
          (err) => {
            console.error(err);
          }
        );
    } else {
      this.hoursOfOperationService.saveHoursOfOperation(this.dialogData.currentHours).subscribe(
        (res) => {
          this.dialogRef.close(res);
        },
        (err) => {
          console.error(err);
        }
      );
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
